var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ly_body" },
    [
      _c(
        "div",
        [
          _c("app-header"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "js_setHeaderHeightToPaddingTop h_100p" },
            [
              _c(
                "transition",
                {
                  attrs: {
                    name: "page-transition",
                    mode: "out-in",
                    appear: "",
                  },
                  on: { "before-enter": _vm.beforeEnter },
                },
                [_c("router-view")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("app-loader"),
      _vm._v(" "),
      _c("app-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }